import View from './view';
export const Preloader = View;
